export default __webpack_public_path__ + "static/media/circle-plus-colored.28a3261f.svg";